var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-aside',{attrs:{"width":"250px"}},[_c('Menu')],1),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }